import { useLanguage } from "@/i18n/LanguageContext";
import { SITE } from "@/lib/site";

const About = () => {
    const { t } = useLanguage();
    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 md:py-32 bg-ella-cream relative"
        >
            <div className="ella-container">
                {/* Header block */}
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
                        <div className="relative">
                            <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-ella-gold/30 to-ella-ink/10 blur-xl opacity-60" />
                            <div className="relative aspect-[4/5] rounded-[1.75rem] overflow-hidden border border-ella-line shadow-[0_24px_60px_rgba(31,29,28,0.12)]">
                                <img
                                    src={SITE.images.consultation}
                                    alt="Transformation · Weite · Klarheit"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="absolute -bottom-6 -right-4 bg-white border border-ella-line rounded-2xl px-5 py-4 shadow-md max-w-[240px]">
                                <p className="ella-overline">{t.about.sign_role}</p>
                                <p className="font-display text-2xl text-ella-ink mt-1.5 leading-none">
                                    {t.about.sign}
                                </p>
                            </div>
                        </div>

                        <div className="mt-12 grid grid-cols-2 gap-5">
                            {t.about.stats.map((s, i) => (
                                <div key={i} data-testid={`about-stat-${i}`} className="border-t border-ella-line pt-4">
                                    <p className="font-display text-3xl md:text-4xl text-ella-ink">{s.value}</p>
                                    <p className="ella-overline mt-2">{s.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <span className="ella-overline" data-testid="about-overline">
                            {t.about.overline}
                        </span>
                        <h2
                            className="ella-headline text-4xl md:text-5xl lg:text-6xl mt-4 text-ella-ink"
                            data-testid="about-title"
                        >
                            {t.about.title}
                        </h2>

                        <blockquote className="mt-8 pl-6 border-l-2 border-ella-gold">
                            <p className="font-serif italic text-2xl md:text-3xl text-ella-ink/85 leading-snug">
                                “{t.about.intro_quote}”
                            </p>
                        </blockquote>

                        <div className="mt-12 space-y-12">
                            {t.about.chapters.map((c, i) => (
                                <article key={i} data-testid={`about-chapter-${i}`} className="relative pl-10">
                                    <span className="absolute left-0 top-2 font-display text-sm text-ella-gold-dark tracking-[0.3em]">
                                        0{i + 1}
                                    </span>
                                    <p className="ella-overline">{c.overline}</p>
                                    <h3 className="font-display text-2xl md:text-3xl mt-2 text-ella-ink">
                                        {c.heading}
                                    </h3>
                                    <p className="mt-4 text-ella-ink/75 leading-relaxed font-light text-[17px]">
                                        {c.body}
                                    </p>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
